import $ from 'jquery';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import * as navigation from 'Navigation';
import StorableResultsTabState from 'results/linked-results/StorableResultsTabState';

import * as GridDAO from '../GridDAO';
import BoxTabState from './BoxTabState';
import GridContentsTabState from './GridContentsTabState';
import GridFileState from './GridFileState';
import GridMetadataTabState from './GridMetadataTabState';

export default class BoxFileState extends GridFileState {
  static fileType: string;
  static openFile: (fileId: string) => JQueryPromise<unknown>;

  editURL(): string {
    return GridDAO.boxEditorURL(this.id);
  }

  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  initialize(...args: Array<any>): void {
    super.initialize(...args);
    this.changeListener = this.changeListener.bind(this);
    this.registerListeners();

    const buffers = new navigation.BufferStates([new navigation.BufferState(), new navigation.BufferState()]);
    this.set({buffers});
    const boxTabState = new BoxTabState({gridId: this.id});
    buffers.at(0).add(boxTabState);
    boxTabState.set({active: true});

    const contentsTabState = new GridContentsTabState({gridId: this.id});
    const secondaryTabs = [contentsTabState, new GridMetadataTabState({gridId: this.id})];
    buffers.at(1).add(secondaryTabs);
    contentsTabState.set({active: true});

    if (this.hasResults()) {
      buffers.at(1).add(new StorableResultsTabState({storableId: this.id}));
    }

    this.initIsWorkspaceSplitFromPreference();
  }
}

BoxFileState.fileType = ModelTypeConstants.BOX;

BoxFileState.openFile = (fileId: string) =>
  $.Deferred()
    .resolve(new BoxFileState({id: fileId}))
    .promise();
